var map = {
	"./backgrounds/alarm-brain.svg": 8939,
	"./backgrounds/background-game.svg": 4772,
	"./backgrounds/background-gamepage-box.svg": 2714,
	"./backgrounds/background-login-header.svg": 4346,
	"./backgrounds/background-module-header.svg": 8521,
	"./backgrounds/background-swirl-grey.svg": 7840,
	"./backgrounds/background-swirl.svg": 3735,
	"./backgrounds/background.svg": 5139,
	"./backgrounds/thinking-brain.svg": 7063,
	"./buttons/button-audio-pause.svg": 2349,
	"./buttons/button-audio-play.svg": 3962,
	"./buttons/button-instructions.svg": 6751,
	"./buttons/button-login.svg": 7701,
	"./buttons/button-red-download.svg": 6400,
	"./buttons/button-red-frame.svg": 1462,
	"./buttons/button-red-medium.svg": 7455,
	"./buttons/button-red-wide.svg": 2853,
	"./buttons/button-red.svg": 4380,
	"./buttons/button-yellow-medium.svg": 7493,
	"./buttons/nav-first.svg": 8662,
	"./buttons/nav-last.svg": 7284,
	"./buttons/nav-next-skip.svg": 1509,
	"./buttons/nav-next.svg": 7899,
	"./buttons/nav-prev-skip.svg": 7168,
	"./buttons/nav-prev.svg": 1546,
	"./frames/frame-brainstorm-category.svg": 4586,
	"./frames/frame-dialogue-example-1.svg": 3094,
	"./frames/frame-dialogue-example-2.svg": 6510,
	"./frames/frame-dialogue.svg": 5693,
	"./frames/frame-game-code.svg": 3132,
	"./frames/frame-match-container.svg": 5281,
	"./frames/frame-menu-item-big-selected.svg": 4378,
	"./frames/frame-menu-item-big.svg": 4337,
	"./frames/frame-menu-item-selected.svg": 614,
	"./frames/frame-menu-item.svg": 2122,
	"./frames/frame-organize-container.svg": 9626,
	"./frames/frame-popup.svg": 9813,
	"./frames/frame-sort-category-hover.svg": 3869,
	"./frames/frame-sort-category.svg": 4278,
	"./icon-arrow-down.svg": 3395,
	"./icon-arrow-left.svg": 5604,
	"./icon-arrow-right.svg": 6058,
	"./icon-audio-progress.svg": 1185,
	"./icon-close.svg": 1924,
	"./icon-info.svg": 4141,
	"./icon-loading.svg": 7213,
	"./icon-lobby.svg": 3396,
	"./icon-logout.svg": 3347,
	"./icon-play.svg": 7371,
	"./icon-remove.svg": 1139,
	"./icon-replay.svg": 934,
	"./icon-select-answer.svg": 5769,
	"./icon-swirl.svg": 9255,
	"./icon-trash.svg": 7727,
	"./icon-video.svg": 7971,
	"./icons/alarm-brain.svg": 7312,
	"./icons/analog-teaching.svg": 9882,
	"./icons/attention.svg": 4723,
	"./icons/calm.svg": 6231,
	"./icons/communication.svg": 4532,
	"./icons/idea-round.svg": 2417,
	"./icons/making-decisions.svg": 3860,
	"./icons/online-teaching.svg": 2578,
	"./icons/plan-of-action.svg": 3818,
	"./icons/problem-solving.svg": 455,
	"./icons/thinking-brain.svg": 1763,
	"./icons/thoughts-helping.svg": 3456,
	"./icons/toolbox.svg": 1860,
	"./illustrations/eks-brugbar-tanke.svg": 5435,
	"./illustrations/eks-negativ-tanke.svg": 5081,
	"./illustrations/eksempel-1.svg": 2311,
	"./illustrations/eksempel.svg": 5996,
	"./illustrations/firkanten.svg": 1516,
	"./illustrations/langsigtet-handleplan.svg": 318,
	"./illustrations/tanketraening-1-2-3.svg": 4728,
	"./logo-cgl.png": 1103,
	"./logo-kfs.png": 9277,
	"./logo-support.png": 277,
	"./logo.svg": 2835,
	"./slides/balance-cirkel-1.svg": 7830,
	"./slides/balance-cirkel-2.svg": 14,
	"./slides/basalplan.svg": 403,
	"./slides/beslutninger.svg": 9689,
	"./slides/breaks.svg": 9603,
	"./slides/case-1.svg": 8349,
	"./slides/case-2.svg": 9186,
	"./slides/case-3.svg": 864,
	"./slides/case-4.svg": 3587,
	"./slides/case-5.svg": 9332,
	"./slides/case-6.svg": 445,
	"./slides/case-7.svg": 3809,
	"./slides/cirkel.svg": 5462,
	"./slides/conflict-behaviours.svg": 6616,
	"./slides/eks-beslutning.svg": 9725,
	"./slides/exsample-1.svg": 5404,
	"./slides/exsample-2.svg": 6626,
	"./slides/fra-tanke-til-handling.svg": 5234,
	"./slides/handleplansskema.svg": 6194,
	"./slides/iderunde.svg": 2708,
	"./slides/kanin-and.svg": 1085,
	"./slides/kommunikation.svg": 5231,
	"./slides/kommunikationstrekanten.png": 2438,
	"./slides/kommunikationstrekanten.svg": 2611,
	"./slides/langsigtet-maal.svg": 3969,
	"./slides/m1-basalboxen.svg": 3330,
	"./slides/m1-eksempel.svg": 3382,
	"./slides/m1-ovelse1.svg": 6390,
	"./slides/m1-ovelse2.svg": 5567,
	"./slides/m1-send-aben-videre.svg": 3134,
	"./slides/m1-slide.svg": 5963,
	"./slides/m2-basalboxen.svg": 8453,
	"./slides/m2-model.svg": 4261,
	"./slides/m2-ovelse.svg": 4187,
	"./slides/m2-slide-1.svg": 4859,
	"./slides/m2-slide-2.svg": 863,
	"./slides/m2-stroop-1.svg": 414,
	"./slides/m2-stroop-2.svg": 129,
	"./slides/m3-basalboxen.svg": 9696,
	"./slides/m3-ovelse-2.svg": 8865,
	"./slides/m3-ovelse.svg": 8688,
	"./slides/m3-slide.svg": 7949,
	"./slides/m3-stem-med-fodderne-1.svg": 6259,
	"./slides/m3-stem-med-fodderne-10.svg": 5514,
	"./slides/m3-stem-med-fodderne-11.svg": 4998,
	"./slides/m3-stem-med-fodderne-12.svg": 7294,
	"./slides/m3-stem-med-fodderne-13.svg": 1240,
	"./slides/m3-stem-med-fodderne-14.svg": 871,
	"./slides/m3-stem-med-fodderne-15.svg": 546,
	"./slides/m3-stem-med-fodderne-16.svg": 9791,
	"./slides/m3-stem-med-fodderne-17.svg": 9285,
	"./slides/m3-stem-med-fodderne-18.svg": 1640,
	"./slides/m3-stem-med-fodderne-19.svg": 5399,
	"./slides/m3-stem-med-fodderne-2.svg": 3581,
	"./slides/m3-stem-med-fodderne-20.svg": 4598,
	"./slides/m3-stem-med-fodderne-21.svg": 7577,
	"./slides/m3-stem-med-fodderne-22.svg": 2425,
	"./slides/m3-stem-med-fodderne-23.svg": 1467,
	"./slides/m3-stem-med-fodderne-3.svg": 8318,
	"./slides/m3-stem-med-fodderne-4.svg": 9944,
	"./slides/m3-stem-med-fodderne-5.svg": 6555,
	"./slides/m3-stem-med-fodderne-6.svg": 6492,
	"./slides/m3-stem-med-fodderne-7.svg": 2391,
	"./slides/m3-stem-med-fodderne-8.svg": 9792,
	"./slides/m3-stem-med-fodderne-9.svg": 8941,
	"./slides/m4-basalboxen.svg": 7719,
	"./slides/m4-case.svg": 2078,
	"./slides/m4-eksempel-1.svg": 7864,
	"./slides/m4-eksempel-2.svg": 4089,
	"./slides/m4-eksempel-3.svg": 7158,
	"./slides/m4-eksempel-4.svg": 510,
	"./slides/m4-eksempel-5.svg": 4585,
	"./slides/m4-ovelse-2.svg": 3173,
	"./slides/m4-ovelse-3.svg": 221,
	"./slides/m4-ovelse.svg": 1400,
	"./slides/m4-slide.svg": 5274,
	"./slides/m5-aktiv-ovelse.svg": 8862,
	"./slides/m5-basalboxen.svg": 4737,
	"./slides/m5-case.svg": 1735,
	"./slides/m5-ovelse.svg": 3156,
	"./slides/m5-slide-2.svg": 2679,
	"./slides/m5-slide.svg": 4241,
	"./slides/m6-aktiv-ovelse.svg": 6503,
	"./slides/m6-basalboxen.svg": 337,
	"./slides/m6-case.svg": 103,
	"./slides/m6-ovelse.svg": 1699,
	"./slides/m6-slide-1.svg": 375,
	"./slides/m6-slide-2.svg": 2043,
	"./slides/m6-slide-3.svg": 5432,
	"./slides/m7-aktiv-ovelse.svg": 4027,
	"./slides/m7-basalboxen.svg": 8873,
	"./slides/m7-case.svg": 2861,
	"./slides/m7-ovelse.svg": 973,
	"./slides/m7-slide-1.svg": 6088,
	"./slides/m7-slide-2.svg": 3223,
	"./slides/m7-slide-3.svg": 5757,
	"./slides/m8-basalquiz-1.svg": 7475,
	"./slides/m8-basalquiz-10.svg": 7160,
	"./slides/m8-basalquiz-11.svg": 1736,
	"./slides/m8-basalquiz-12.svg": 6340,
	"./slides/m8-basalquiz-13.svg": 1504,
	"./slides/m8-basalquiz-14.svg": 3199,
	"./slides/m8-basalquiz-15.svg": 6928,
	"./slides/m8-basalquiz-16.svg": 4578,
	"./slides/m8-basalquiz-17.svg": 6781,
	"./slides/m8-basalquiz-18.svg": 1711,
	"./slides/m8-basalquiz-19.svg": 9191,
	"./slides/m8-basalquiz-2.svg": 8645,
	"./slides/m8-basalquiz-20.svg": 5288,
	"./slides/m8-basalquiz-21.svg": 53,
	"./slides/m8-basalquiz-22.svg": 3725,
	"./slides/m8-basalquiz-23.svg": 6772,
	"./slides/m8-basalquiz-24.svg": 5411,
	"./slides/m8-basalquiz-25.svg": 7702,
	"./slides/m8-basalquiz-26.svg": 8315,
	"./slides/m8-basalquiz-27.svg": 5285,
	"./slides/m8-basalquiz-28.svg": 1784,
	"./slides/m8-basalquiz-3.svg": 339,
	"./slides/m8-basalquiz-4.svg": 5814,
	"./slides/m8-basalquiz-5.svg": 3553,
	"./slides/m8-basalquiz-6.svg": 2904,
	"./slides/m8-basalquiz-7.svg": 3943,
	"./slides/m8-basalquiz-8.svg": 4360,
	"./slides/m8-basalquiz-9.svg": 7911,
	"./slides/m8-basalquiz.pdf": 4705,
	"./slides/m8-ovelse-1.svg": 3807,
	"./slides/m8-ovelse-2.svg": 8298,
	"./slides/m8-ovelse.svg": 1345,
	"./slides/m8-send-aben-videre.svg": 2455,
	"./slides/problemloesningsskema.svg": 906,
	"./slides/quotes.svg": 7318,
	"./slides/stroop-1.svg": 7817,
	"./slides/stroop-2.svg": 2821,
	"./slides/tanketraening-eks-1.svg": 2769,
	"./slides/tanketraening-eks-2.svg": 1245,
	"./slides/thinking-example.svg": 6590,
	"./slides/thought-and-feeling.svg": 2356,
	"./slides/thought-trap.svg": 8066,
	"./slides/vaerktoejskasse.svg": 5775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;